import { FC } from 'react';

import { selectRatePlanLegalTerms } from '@telialt/utils/src/eshopSelectors';

import { useCartQuery } from '../../hooks/queries/useCartQuery';
import { LegalTextWrapper } from './LegalText.styles';

export const RatePlanLegalText: FC = () => {
    const { cart } = useCartQuery();
    const ratePlanLegalTerms = selectRatePlanLegalTerms(cart);

    if (!ratePlanLegalTerms) {
        return null;
    }

    return <LegalTextWrapper content={ratePlanLegalTerms} />;
};
